import React, { useContext, useRef } from "react";
import { GlobalContext } from "../../../GlobalContext";
import { DisabledAndLoadingContext } from "../../../core/context/DisabledAndLoading";
import { FormFields } from "../../../core/api/contracts/FormFields";
import { UpsolverLocalStorage } from "../../../core/UpsolverLocalStorage";
import { SimpleFormView } from "../../../core/views/UForm";
import { UFormField } from "../../../core/views/UFormField";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import { Button } from "../../../core/views/Button";
import { usePostLogin } from "../provider/Context";
import useVerificationErrorHandler from "../../useVerificationErrorHandler";
import { useLoginEventTrackers } from "../provider/useLoginEventTrackers";

function UpsolverAuthenticationLogin() {
  const { auth } = useContext(GlobalContext);
  const { setLoading, loading } = useContext(DisabledAndLoadingContext);
  const { onLoginSuccess } = usePostLogin();
  const verificationErrorHandler = useVerificationErrorHandler();
  const tracker = useLoginEventTrackers();
  const loginForm = useRef(
    new FormFields()
      .addMultipleFieldProperties([
        { name: "email", label: "Email Address", type: "text", rule: "required|email|min:5" },
        { name: "password", label: "Password", type: "password", rule: "required|string|min:5" },
      ])
      .createForm()
  );

  const error = (text: string) => {
    loginForm.current.$("email").invalidate(text);
  };

  const submitForm = async (values: any) => {
    setLoading(true);
    const loginReply = await auth.authMethodLogin(
      values,
      "upsolver",
      () => {
        error("Wrong email/password entered.");
      },
      (err) => {
        tracker.trackLoginError(err);
        if (!verificationErrorHandler(err)) {
          error("Cannot connect to Upsolver Streams, Please try again later");
        }
      }
    );
    UpsolverLocalStorage.removeKey("profilePicUrl");
    onLoginSuccess(loginReply);

    setLoading(false);
  };
  return (
    <div className="create-feature-form">
      {loginForm && (
        <SimpleFormView form={loginForm.current} onSuccess={submitForm}>
          <div className="form-input-group">
            <UFormField input={loginForm.current.$("email")} />
          </div>

          <div className="form-input-group">
            <UFormField input={loginForm.current.$("password")} />
          </div>

          <p style={{ marginTop: 10 }}>
            <Link to="/forgot-password" data-automation-name="forgot-password">
              Forgot your Password?
            </Link>
          </p>

          <Box width="100%" textAlign="center">
            <Button type="submit" loading={loading}>
              Log In
            </Button>
          </Box>
        </SimpleFormView>
      )}
    </div>
  );
}
export default UpsolverAuthenticationLogin;
